/* global DocumentTouch */
import MicroModal from "../autoload/modal.js"; // es6 module
import mixitup from "../autoload/mixitup.min";
import Xpandy from "../autoload/xpandy-polyfill.min.js";
import Filtering from "../filtering.js";

export default {
    init() {
        if (
            "ontouchstart" in window ||
            (window.DocumentTouch && document instanceof DocumentTouch) ||
            navigator.MaxTouchPoints > 0 ||
            navigator.msMaxTouchPoints > 0
        ) {
            document.documentElement.className = document.documentElement.className.replace(
                /\bno-touch\b/,
                "touch"
            );
        }

        let raf =
            window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.msRequestAnimationFrame ||
            window.oRequestAnimationFrame;

        // ---------------------------------------------------------------------
        // Header fade effect on homepage

        // initialize modal
        MicroModal.init({
            disableScroll: true, // [5]
            awaitCloseAnimation: true, // [7]
            debugMode: false, // [8]
        });

        const header = document.querySelector(".Header");

        const headerHomepageFade = () => {
            if (window.pageYOffset < 40) {
                header.classList.add("is-top");
            } else {
                header.classList.remove("is-top");
            }

            raf(headerHomepageFade);
        };

        if (document.querySelector(".home")) {
            headerHomepageFade();
        }

        // ---------------------------------------------------------------------
        // General page animations
        //

        if (window.IntersectionObserver) {
            let observer = new IntersectionObserver(
                (entries, observer) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            entry.target.classList.remove("is-hidden");
                            entry.target.classList.add("is-visible");
                            observer.unobserve(entry.target);
                        }
                    });
                },
                { rootMargin: "0px 0px -200px 0px" }
            );

            Array.from(
                document.querySelectorAll("main > section:not(.no-anim)")
            ).forEach((section) => {
                section.classList.add("is-hidden");
                observer.observe(section);
            });
        }

        // let sectionsNodes = document.querySelectorAll('main > section:not(.no-anim)');
        // // let buffer = 200;

        // let sections = Array.from(sectionsNodes).map(section => {
        //     section.classList.add('is-hidden');

        //     return {
        //         section: section,
        //         bottom: section.getBoundingClientRect().bottom
        //     };
        // });

        // const sectionAnimations = () => {
        //     let windowBottom = window.pageYOffset + window.innerHeight;

        //     sections.forEach(section => {
        //         if (section.bottom < windowBottom) {
        //             section.section.classList.remove('is-hidden');
        //             section.section.classList.add('is-visible');
        //         }
        //     });

        //     raf(sectionAnimations);
        // };

        // if (sections.length) {
        //     sectionAnimations();
        // }

        // ---------------------------------------------------------------------

        let xpandy = new Xpandy(".Xpandy", {
            autoCloseOnOpen: true,
            items: ".Xpandy-item",
            arrow: true,
            arrowPosition: "right",
            equalHeights: true,
            previewTemplate: (config) => `
            <div class="Xpandy-wrapper">
                ${config.arrow ? '<div class="Xpandy-arrow"></div>' : ""}
                <div class="Xpandy-container">
                    <div class="Xpandy-body">
                        <div class="Xpandy-wrap">
                            <div class="Xpandy-close--wrapper">
                                <span class="Xpandy-close"></span>
                            </div>
                            <div class="Xpandy-base"></div>
                        </div>
                    </div>
                </div>
            </div>
            `,
            callbacks: {
                onInit: () => {
                    if (document.querySelector(".js-filtering")) Filtering();
                },
                onClose: () => {},
                onOpen: () => {},
            },
        });

        if (window.location.hash) {
            var xpandySlug = window.location.hash.substr(1);
            var xpandyTarget = document.querySelector("." + xpandySlug);

            console.log(xpandySlug);

            if (xpandyTarget) {
                xpandy[0].togglePreview(xpandyTarget);

                xpandyTarget.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "nearest",
                });
            }
        }

        if (
            document.querySelector(".js-filtering") &&
            !document.querySelector(".Xpandy")
        ) {
            Filtering();
        }
        if (document.querySelector(".js-teamfiltering")) {
            mixitup(".js-teamfiltering", {
                animation: {
                    duration: 250,
                    nudge: true,
                    easing: "ease-out",
                    reverseOut: false,
                    effects: "fade",
                },
            });
            document.getElementById("teamOpen").click();
        }

        // -----------------------------------------------

        function disableTouchMove(e) {
            e.preventDefault();
        }

        function openActions() {
            document.documentElement.classList.add("u-lockWindow");
            document.body.classList.add("u-lockWindow");

            document.documentElement.addEventListener(
                "touchmove",
                disableTouchMove,
                false
            );
        }

        function closeActions() {
            document.documentElement.classList.remove("u-lockWindow");
            document.body.classList.remove("u-lockWindow");

            document.documentElement.removeEventListener(
                "touchmove",
                disableTouchMove,
                false
            );
        }

        // let debounceResize = debounce(function () {
        //     if (window.innerWidth > 1180 && header.classList.contains('mobile-is-open')) {
        //         toggleMenu();
        //     }
        // }, 250);

        // window.addEventListener('resize', debounceResize);

        const mobileIcon = document.querySelector(".Header-mobileIcon");

        const toggleMenu = (e) => {
            e.preventDefault();

            let nav = document.querySelector(".Nav");
            nav.classList.toggle("is-open");
            mobileIcon.classList.toggle("is-open");
            document.body.classList.toggle("is-open");

            if (nav.classList.contains("is-open")) {
                openActions();
            } else {
                closeActions();
            }
        };

        mobileIcon.addEventListener("click", toggleMenu);

        // ---------------------------------------------------------------------

        $(".menu-item-has-children > a").click(function (e) {
            if (window.innerWidth <= 1024) {
                e.preventDefault();

                $(this).parent().find(".sub-menu").toggle();

                $(this).parent().toggleClass("submenu-is-open");
            }
        });

        // ---------------------------------------------------------------------

        let submenu = document.querySelector(".Hero-submenu");

        if (window.innerWidth < 950 && submenu) {
            let active = submenu.querySelector(".active");
            let wrap = submenu.querySelector(".wrap");
            let scrollLeft = active.offsetLeft;

            if (scrollLeft > window.innerWidth) {
                wrap.scrollLeft = scrollLeft;
            }
        }

        67;

        //Email Obfuscation
        $(document).ready(function () {
            // executes when HTML-Document is loaded and DOM is ready
            $(".EmailOb").each(function () {
                var unob = $(this).text();
                unob = unob.split("+").join("");
                $(this).text(unob);
                $(this).css('opacity', 1);
            });

            $(".EmailOb").on("touchstart", function () {
                var unob = $(this).attr("href");
                unob = unob.split("+").join("");
                $(this).attr("href", unob);
            });

            $(".EmailOb").on("click mouseenter", function () {
                var unob = $(this).attr("href");
                unob = unob.split("+").join("");
                $(this).attr("href", unob);
            });
        });
    },

    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js